<template lang="pug">
  .container.grid-xl.py-2
    .panel
      .panel-header
        .h4.text-primary Novo Modelo de Documento
        div Tipo: #[b {{ `enums.db.enum_doc_tipo.${$route.params.docTipo}` | translate }}]
        .divider
        steps.pt-2(:steps="steps" :step-style="{ fontSize: '.55rem' }")
        .divider
      .panel-body.mb-2
        .empty(v-if="loading")
          .loading-container
            .loading.loading-lg
          p.empty-title.h5 Carregando dados
          p.empty-subtitle Aguarde um momento, estamos buscando as informações para você
        router-view(v-else)
</template>

<script>
import api from '@/api/sistema/docModelos'
import { LocalStorageFacade } from 'paliari-js-utils'
import DocModelo from '@/models/DocModelo'

export default {
  props: {
    docTipo: { type: String, required: true },
  },
  data() {
    return {
      loading: false,
      steps: [
        { routeName: 'sistema.docModelos.new.info', title: 'Informações' },
        {
          routeName: 'sistema.docModelos.new.parametros',
          title: 'Parâmetros',
        },
        {
          routeName: 'sistema.docModelos.new.calculo',
          title: 'Cálculo',
        },
        {
          routeName: 'sistema.docModelos.new.reincidencia',
          title: 'Reincidência',
        },
        {
          routeName: 'sistema.docModelos.new.assuntos',
          title: 'Assuntos',
        },
        {
          routeName: 'sistema.docModelos.new.irregularidades',
          title: 'Irregularidades',
        },
        {
          routeName: 'sistema.docModelos.new.integracao',
          title: 'Integração',
        },
        {
          routeName: 'sistema.docModelos.new.textos',
          title: 'Textos',
        },
        {
          routeName: 'sistema.docModelos.new.confirmar',
          title: 'Confirmar',
        },
      ],
    }
  },
  async created() {
    const resource = LocalStorageFacade.getItem('docModelo')
    if (resource) return
    try {
      this.loading = true
      const data = await api.new(this.docTipo)
      LocalStorageFacade.setItem('docModelo', new DocModelo(data))
    } catch (e) {
      this.$toaster.error('Falha ao inicializar modelo')
    } finally {
      this.loading = false
    }
  },
  destroyed() {
    LocalStorageFacade.removeItem('docModelo')
  },
}
</script>
